import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Keynote`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://primer.style/presentations/presentation-formats/keynote"
      }}>{`Keynote`}</a>{` template is available for GitHub employees on `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1rneeYAzbt7yZrqMjkzBTNKxkNH8h24ok"
      }}>{`Google Drive`}</a>{`.`}</p>
    <h2>{`PowerPoint`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://primer.style/presentations/presentation-formats/powerpoint"
      }}>{`PowerPoint`}</a>{` template is available for GitHub employees on `}<a parentName="p" {...{
        "href": "https://drive.google.com/file/d/1mnxk1oVKw1-RtAy5iQpXPSNbxBvbrKox"
      }}>{`Google Drive`}</a>{`.`}</p>
    <h2>{`Google Slides`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://primer.style/presentations/presentation-formats/google-slides"
      }}>{`Google Slides`}</a>{` template is available as a custom theme within the `}<a parentName="p" {...{
        "href": "https://docs.google.com/presentation/u/0/?tgif=d&ftv=1"
      }}>{`template gallery`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      